import moment from 'moment'

import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

export const useBalanceRange = (
  timeBlocksBalanceStartOn?: string,
  timeBlocksBalanceEndon?: string
) => {
  const { stringDateFrom, stringDateTo } = useAttendanceDateNavigator()

  const today = moment()
  const yesterday = today.subtract(1, 'day')

  const balanceRangeStartOn = timeBlocksBalanceStartOn ?? stringDateFrom
  const endOn = moment(timeBlocksBalanceEndon ?? stringDateTo)
  // For the Balance and Compensation counters:
  // - The start date is the beginning of the cycle.
  // - The end date depends on the period being checked:
  //   - For current or future weeks in the current month, set it to yesterday.
  //   - For past periods, set it to the end of the selected period.
  const balanceRangeEndOn = moment.min(endOn, yesterday).format('YYYY-MM-DD')

  return { balanceRangeStartOn, balanceRangeEndOn }
}
